import React, { useState, useEffect, useContext, useRef } from "react";
import ActorCard from "./ActorCard";
// import { actorData } from '../dumyData';
// import SearchFilter from '../castingCalls/SearchFilter'; // Removed
import Pagination from "@mui/material/Pagination";
import {
  Box,
  Button, // Added Button component for toggle
  Typography,
} from "@mui/material";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import { getAllActors } from "../../api/axios";
import { Spinner } from "react-bootstrap";
import ActorsSelectingList from "./ActorsSelectingList";
import { useTheme } from "@mui/material/styles";
import { AuthContext } from "../../context/AuthContext";
// import axios from 'axios'; // Removed
import ActorSearchFilter from "./ActorSearchFilter"; // Import the new filter component
import FilterListIcon from "@mui/icons-material/FilterList"; // Import filter icon
import CloseIcon from "@mui/icons-material/Close"; // Import close icon

const weightMarks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 100,
    label: "100",
  },
  {
    value: 200,
    label: "200",
  },
  {
    value: 300,
    label: "300",
  },
  {
    value: 400,
    label: "400",
  },
  {
    value: 500,
    label: "500",
  },
];

const hairColors = [
  {
    value: "black",
    color: "#000",
  },
  {
    value: "brown",
    color: "#592d06",
  },
  {
    value: "red",
    color: "#de1102",
  },
  {
    value: "blonde",
    color: "#FFB400",
  },
  {
    value: "gray",
    color: "#97928B",
  },
];

const eyeColors = [
  {
    value: "black",
    color: "#000",
  },
  {
    value: "brown",
    color: "#592d06",
  },
  {
    value: "blue",
    color: "#1569C7",
  },
  {
    value: "green",
    color: "#19A337",
  },
  {
    value: "gray",
    color: "#97928B",
  },
];

const ethnicities = [
  {
    value: "black",
    label: "African American",
  },
  {
    value: "asian",
    label: "Asian",
  },
  {
    value: "latino/hispanic",
    label: "Latino  Hispanic",
  },
  {
    value: "white/caucasian",
    label: "European American",
  },
  {
    value: "middle_eastern",
    label: "Middle Eastern",
  },
  {
    value: "native_american",
    label: "Native American",
  },
  {
    value: "pacific_islander",
    label: "Pacific Islander",
  },
  {
    value: "indian/south_asian",
    label: "Indian  South Asian",
  },
  {
    value: "other",
    label: "Other",
  },
];
const Genders = ["Male", "Female", "Non-Binary", "Transgender"];
const ActorsList = () => {
  const theme = useTheme();
  const { role } = useContext(AuthContext);
  const [ageValue, setAgeValue] = useState([18, 100]);
  const [heightValue, setHeightValue] = useState([0, 96]);
  const [weightValue, setWeightValue] = useState([0, 500]);
  const [searchInputs, setSearchInputs] = useState({
    name: "",
    country: "",
    zip: "",
    radius: "",
    age: [18, 100], // Initialized as array
    gender: [],
    hobby: "",
    eyeColor: [],
    hairColor: [],
    weight: [0, 500], // Initialized as array
    height: [0, 96], // Initialized as array
    ethnicity: [],
    location: null, // For selected address object
    jobTitles: "", // Changed to string for single selection
  });
  const [isFiltered, setIsFiltered] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [pages, setPages] = useState(1);

  const [loading, setLoading] = useState(true);
  const [actorsList, setActorsList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showFilter, setShowFilter] = useState(false); // State for filter visibility

  // Location search states and refs, now passed to ActorSearchFilter
  const [addressContent, setAddressContent] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [searchRadius, setSearchRadius] = useState(10);
  const [error, setError] = useState("");
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    setPages(totalPages);
  }, [filteredData]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Helper function to calculate distance between two points using Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 3958.8; // Earth's radius in miles
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance; // Distance in miles
  };

  const parseHeight = (height) => {
    if (!height) return 0; // If height is undefined or empty, return 0

    // Check if the height is in the format "23ft 76in"
    if (typeof height === "string" && height.includes("ft")) {
      const [feet, inches] = height.split(" "); // Split into feet and inches
      const feetValue = parseInt(feet.replace("ft", ""), 10); // Extract feet value
      const inchesValue = parseInt(inches.replace("in", ""), 10); // Extract inches value
      return feetValue * 12 + inchesValue; // Convert to total inches
    }

    // If height is a plain number, assume it's already in inches
    return parseFloat(height);
  };

  const normalizeLocationText = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  const getLocationTerms = (location) => {
    if (!location) return [];

    const address = location.address || {};
    const rawTerms = [
      address.city,
      address.town,
      address.village,
      address.county,
      address.state,
      address.postcode,
      address.country,
      ...(location.display_name ? location.display_name.split(",") : []),
    ];

    return [...new Set(rawTerms.map(normalizeLocationText))]
      .filter(Boolean)
      .filter((term) => term.length >= 3 || /^\d+$/.test(term));
  };

  const matchesLocationFilter = (item, location) => {
    const locationTerms = getLocationTerms(location);
    if (!locationTerms.length) {
      return true;
    }

    const searchableFields = [
      normalizeLocationText(item.profile?.location),
      normalizeLocationText(item.user?.location),
      normalizeLocationText(item.user?.zipCode),
    ].filter(Boolean);

    if (!searchableFields.length) {
      return false;
    }

    return locationTerms.some((term) =>
      searchableFields.some(
        (field) => field.includes(term) || term.includes(field),
      ),
    );
  };

  const applyFilters = (filters) => {
    let filtered = actorsList;
    console.log("Applying filters:", filters);

    if (filters.name) {
      filtered = filtered.filter(
        (item) =>
          item.user.firstName
            .toLowerCase()
            .includes(filters.name.toLowerCase()) ||
          item.user.lastName.toLowerCase().includes(filters.name.toLowerCase()),
      );
    }
    if (filters.jobTitles) {
      const selectedCategory = filters.jobTitles.trim().toLowerCase();
      filtered = filtered.filter((item) => {
        const categories = Array.isArray(item.profile?.category)
          ? item.profile.category
          : String(item.profile?.category || '').split(',');

        return categories.some(
          (category) => category.trim().toLowerCase() === selectedCategory,
        );
      });
    }

    if (filters.age && (filters.age[0] !== 18 || filters.age[1] !== 100)) {
      filtered = filtered.filter(
        (item) =>
          item.profile?.age >= filters.age[0] &&
          item.profile?.age <= filters.age[1],
      );
    }
    if (filters.gender.length > 0) {
      filtered = filtered.filter((item) =>
        filters.gender.includes(item?.user?.gender?.toLowerCase()),
      );
    }
    if (filters.hobby) {
      filtered = filtered.filter((item) =>
        item.profile.hobby.toLowerCase().includes(filters.hobby.toLowerCase()),
      );
    }
    if (filters.eyeColor.length > 0) {
      filtered = filtered.filter((item) =>
        filters.eyeColor.includes(item?.profile?.eyeColor?.toLowerCase()),
      );
    }
    if (filters.hairColor.length > 0) {
      filtered = filtered.filter((item) =>
        filters.hairColor.includes(item?.profile?.hairColor?.toLowerCase()),
      );
    }
    if (
      filters.weight &&
      (filters.weight[0] !== 0 || filters.weight[1] !== 500)
    ) {
      filtered = filtered.filter(
        (item) =>
          item.profile?.weight >= filters.weight[0] &&
          item.profile?.weight <= filters.weight[1],
      );
    }
    if (
      filters.height &&
      (filters.height[0] !== 0 || filters.height[1] !== 96)
    ) {
      filtered = filtered.filter((item) => {
        const actorHeight = parseHeight(item.profile?.height);
        return (
          actorHeight >= filters.height[0] && actorHeight <= filters.height[1]
        );
      });
    }
    if (filters.ethnicity.length > 0) {
      filtered = filtered.filter((item) =>
        filters.ethnicity.includes(
          item.profile?.ethnicity?.toLowerCase() ||
            item.user?.ethnicity?.toLowerCase(),
        ),
      );
    }

    // Location filtering uses saved text fields because actor profiles
    // do not currently store latitude/longitude coordinates.
    if (filters.location) {
      filtered = filtered.filter((item) =>
        matchesLocationFilter(item, filters.location),
      );
    }

    setFilteredData(filtered);
    setPage(1);
  };

  const handleSearch = (filters) => {
    applyFilters(filters);
  };

  const handleResetFilters = () => {
    setSearchInputs({
      name: "",
      country: "",
      zip: "",
      radius: "",
      age: [18, 100], // Reset age to default range
      gender: [],
      hobby: "",
      eyeColor: [],
      hairColor: [],
      weight: [0, 500], // Reset weight to default range
      height: [0, 96], // Reset height to default range
      ethnicity: [],
      location: null, // Clear selected location
      jobTitles: "",
    });
    setAgeValue([18, 100]); // Reset age slider value
    setHeightValue([0, 96]); // Reset height slider value
    setWeightValue([0, 500]); // Reset weight slider value
    setAddressContent(""); // Clear address content
    setSelectedAddress(null); // Clear selected address
    setSuggestions([]); // Clear suggestions
    setFilteredData(actorsList); // Reset filtered data to original list
    setPage(1);
  };

  const GetAllActors = async (filters) => {
    nprogress.start();
    setLoading(true);
    try {
      const res = await getAllActors(filters);
      if (res.success) {
        setActorsList(res.users);
      }
    } catch (error) {
      console.error("error fetching actors", error);
    } finally {
      nprogress.done();
      setLoading(false);
    }
  };

  useEffect(() => {
    const { jobTitles } = searchInputs;
    GetAllActors({ jobTitles });
  }, [searchInputs.jobTitles]);

  useEffect(() => {
    applyFilters(searchInputs);
  }, [actorsList]);

  useEffect(() => {
    setIsFiltered(
      Object.values(searchInputs).some((input) => {
        if (Array.isArray(input)) {
          // For array filters like gender, eyeColor, hairColor, ethnicity
          return input.length > 0;
        }
        // For range filters like age, height, weight
        if (Array.isArray(input) && input.length === 2) {
          if (input[0] === 18 && input[1] === 100) return false; // Default age
          if (input[0] === 0 && input[1] === 96) return false; // Default height
          if (input[0] === 0 && input[1] === 500) return false; // Default weight
          return true;
        }
        // For location object
        if (typeof input === "object" && input !== null) {
          return Object.keys(input).length > 0;
        }
        return input !== ""; // For string inputs like name, hobby
      }),
    );
  }, [searchInputs]);

  const actorCount = filteredData?.length;
  const paginatedData = filteredData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage,
  );

  const handlePagination = (e, value) => {
    setPage(value);
  };

  if (loading) {
    return (
      <div className="spinner-page">
        <Spinner className="spinner" />
      </div>
    );
  }
  return (
    <div className="castingCall-list-full-wrapper">
      <div className="castingCall-list-conainer">
        <div
          className="castingCall-clear-filter"
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              fontSize: {
                xs: "18px",
                sm: "20px",
                md: "20px",
                lg: "24px",
              },
            }}
          >
            {actorCount} Active Actors
          </Typography>
          <Button
            variant="outlined"
            onClick={() => setShowFilter(!showFilter)}
            style={{
              width: window.innerWidth < 768 ? "100%" : "auto",
            }}
            sx={{ display: { xs: "flex", md: "none" } }} // Show on small screens
            startIcon={showFilter ? <CloseIcon /> : <FilterListIcon />}
          >
            {showFilter ? "Hide Filters" : "Show Filters"}
          </Button>
          {isFiltered && (
            <div onClick={handleResetFilters} className="filter-clear">
              Reset filters
            </div>
          )}
        </div>
        <div className="seperate-line mb-4"></div>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            gap: {
              xs: "10px",
              sm: "20px",
              md: "20px",
              xl: "40px",
            },
            flexDirection: { xs: "column", md: "row" }, // Stack on small, side-by-side on medium+
          }}
        >
          <Box sx={{ flex: "1 1 auto" }}>
            {" "}
            {/* Actor List */}
            <div className="castingCall-list">
              {paginatedData.length === 0 && (
                <Typography
                  variant="h5"
                  sx={{ color: `${theme.palette.text.secondary}` }}
                >
                  No Actors Found
                </Typography>
              )}
              <ActorsSelectingList actors={paginatedData} />
              <div className="pagination">
                <Pagination
                  count={pages}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                />
              </div>
            </div>
          </Box>
          <Box
            sx={{
              flex: "0 0 250px", // Fixed width on larger screens
              maxWidth: { xs: "100%", md: "250px" }, // Max width for filter
              display: { xs: showFilter ? "flex" : "none", md: "flex" }, // Toggle visibility on small, always show on medium+
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <ActorSearchFilter
              searchInputs={searchInputs}
              setSearchInputs={setSearchInputs}
              handleSearch={handleSearch}
              ageValue={ageValue}
              setAgeValue={setAgeValue}
              heightValue={heightValue}
              setHeightValue={setHeightValue}
              weightValue={weightValue}
              setWeightValue={setWeightValue}
              addressContent={addressContent}
              setAddressContent={setAddressContent}
              suggestions={suggestions}
              setSuggestions={setSuggestions}
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              searchRadius={searchRadius}
              setSearchRadius={setSearchRadius}
              setError={setError}
              debounceTimeoutRef={debounceTimeoutRef}
            />
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default ActorsList;
